namespace appn.views.logs.index {

    class InitArgs {
        includesDescription: boolean = false;
        isPopup: boolean = false;
    }

    let _initArgs: InitArgs;
    let _dataTable: any = null;
    let _historyDataTable: any = null;
    let totalTables: number = 0;

    export function init(args: InitArgs): void {
        _initArgs = args;
        createDataTable();
        addEvents();
    }

    function addEvents() {
        $('.toggle-history').click(function() {
            const tr = $(this).closest('tr');
            const $rowOptions = $(this).closest('.rowOptions');
            const $icon = $(this).find('i');

            if (_dataTable.fnIsOpen(tr)) {
                _dataTable.fnClose(tr);
                appn.ui.handleParentResize(0, 50);
                $icon.removeClass('fa-chevron-up').addClass('fa-history').attr('title', T('show history'));
                $rowOptions.removeClass('d-inline');
                return;
            }

            totalTables += 1;
            const html = tr.find('.history-table-container').html();
            const childRow = _dataTable.fnOpen(tr, html, 'info_row');
            $(childRow).addClass('history-table-show_' + totalTables.toString());
            createHistoryDataTable();
            $icon.removeClass('fa-history').addClass('fa-chevron-up').attr('title', T('hide history'));
            $rowOptions.addClass('d-inline');
        });
    }

    function createHistoryDataTable() {
        _historyDataTable = appn.dataTable.create('.history-table-show_' + totalTables.toString() + ' table', {
            sDom: appn.dataTable.genSDom(0, 0, 0), // sDom empty
            scrollY: null,
            searching: false,
            paging: false,
            info: false,
            bSort: false, // don't allow sorting cos might be non-sort friendly user format
            ordering: false,
            hasFilters: false,
            aoColumns: [
                { bSortable: false, sWidth: '20%' }, // start
                { bSortable: false, sWidth: '25%' }, // end
                { bSortable: false, sWidth: '15%' }, // time
                { bSortable: false, sWidth: '40%' }  // result
            ],
            fnInitComplete: function () {
                appn.ui.handleParentResize(0, 50);
            }
        });
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.logs-table', {
            scrollY: null,
            iDisplayLength: 50,
            paging: false, // a max of 25 entries are returned at once
            bSort: false, // don't allow sorting cos might be non-sort friendly user format
            ordering: false,
            hasFilters: false,
            searching: !_initArgs.isPopup,
            aoColumns: getColumnConfig(),
            fnInitComplete: function () {
                if (!_initArgs.isPopup)
                    appn.dataTable.addSearchPlaceholder(T(`Filter results where the Log's <b>Rows or Columns</b> contain a keyword typed in here.`), appn.emptyString, 'left');
            }
        });
    }

    function getColumnConfig(): Array<IDTColumns> {
        if (_initArgs.includesDescription)
            return [
                { bSortable: false, sWidth: '20%' }, // eventDate 
                { bSortable: false, sWidth: '10%' }, // stat
                { bSortable: false, sWidth: '15%' }, // name
                { bSortable: false, sWidth: '15%' }, // type
                { bSortable: false, sWidth: '40%' }  // result
            ] as Array<IDTColumns>;

        return [
            { bSortable: false, sWidth: '20%' }, // eventDate
            { bSortable: false, sWidth: '20%' }, // stat
            { bSortable: false, sWidth: '20%' }, // type
            { bSortable: false, sWidth: '40%' }  // result
        ] as Array<IDTColumns>;
    }
}

